import Input from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import Checkbox from "./Checkbox";
import Button from "./Button";
import DataGrid from "./DataGrid";
import Autocomplete from "./Autocomplete"
import CheckboxGroup from "./CheckboxGroup";
import MultiselectAutocomplete from "./MultiselectAutocomplete";
import DropDown from "./DropDown";
import { ExcelImportTool } from "./ExcelImportTool";
//import DesktopDatePicker from "./DesktopDatePicker";
const BiztranControls = {
  Input,
  RadioGroup,
  Select,
  Checkbox,
  Button,
  DataGrid,
  Autocomplete,
  CheckboxGroup,
  MultiselectAutocomplete,
  DropDown,
  ExcelImportTool,
  /* DesktopDatePicker */
};

export default BiztranControls;
